import { Component, Input } from '@angular/core';
import { FormControl } from "@angular/forms";

@Component({
    selector: 'nc-textarea',
    template: `
        <div class="form-group">
            <mat-form-field>
                <mat-label>{{label}}</mat-label>
                <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" [formControl]="control"></textarea>
                <mat-error><error-message [forControl]="control"></error-message></mat-error>
            </mat-form-field>
        </div>`,
})
export class NcTextarea {

    @Input()
    control: FormControl;

    @Input()
    label: any;

}
